"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CrossCircle_exports = {};
__export(CrossCircle_exports, {
  default: () => CrossCircle_default
});
module.exports = __toCommonJS(CrossCircle_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M16 8.00415C15.8125 7.81668 15.5582 7.71136 15.293 7.71136C15.0278 7.71136 14.7735 7.81668 14.586 8.00415L12 10.5902L9.414 8.00415C9.2254 7.82199 8.9728 7.7212 8.7106 7.72348C8.4484 7.72575 8.19759 7.83092 8.01218 8.01633C7.82677 8.20174 7.7216 8.45255 7.71933 8.71475C7.71705 8.97695 7.81784 9.22955 8 9.41815L10.586 12.0042L8 14.5902C7.81784 14.7788 7.71705 15.0314 7.71933 15.2936C7.7216 15.5557 7.82677 15.8066 8.01218 15.992C8.19759 16.1774 8.4484 16.2825 8.7106 16.2848C8.9728 16.2871 9.2254 16.1863 9.414 16.0042L12 13.4181L14.586 16.0042C14.7746 16.1863 15.0272 16.2871 15.2894 16.2848C15.5516 16.2825 15.8024 16.1774 15.9878 15.992C16.1732 15.8066 16.2784 15.5557 16.2807 15.2936C16.283 15.0314 16.1822 14.7788 16 14.5902L13.414 12.0042L16 9.41815C16.1875 9.23062 16.2928 8.97631 16.2928 8.71115C16.2928 8.44599 16.1875 8.19168 16 8.00415Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M12 0.00415039C9.62663 0.00415039 7.30655 0.707938 5.33316 2.02652C3.35977 3.34509 1.8217 5.21924 0.913451 7.41195C0.00519943 9.60466 -0.232441 12.0175 0.230582 14.3452C0.693605 16.673 1.83649 18.8112 3.51472 20.4894C5.19295 22.1677 7.33115 23.3106 9.65892 23.7736C11.9867 24.2366 14.3995 23.999 16.5922 23.0907C18.7849 22.1825 20.6591 20.6444 21.9776 18.671C23.2962 16.6976 24 14.3775 24 12.0042C23.9966 8.82261 22.7312 5.77236 20.4815 3.52267C18.2318 1.27298 15.1815 0.00759147 12 0.00415039ZM12 22.0042C10.0222 22.0042 8.08879 21.4177 6.4443 20.3188C4.79981 19.22 3.51809 17.6582 2.76121 15.831C2.00433 14.0037 1.8063 11.9931 2.19215 10.0532C2.578 8.11344 3.53041 6.33161 4.92894 4.93308C6.32746 3.53456 8.10929 2.58215 10.0491 2.1963C11.9889 1.81045 13.9996 2.00848 15.8268 2.76536C17.6541 3.52223 19.2159 4.80396 20.3147 6.44845C21.4135 8.09294 22 10.0263 22 12.0042C21.9971 14.6554 20.9426 17.1973 19.0679 19.072C17.1931 20.9467 14.6513 22.0012 12 22.0042Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgCrossCircle = SvgIcon;
var CrossCircle_default = SvgCrossCircle;
//# sourceMappingURL=CrossCircle.js.map